import Image from 'next/image'
import { Grid } from '@mui/material'

// Types
import type { LogoProps } from '@/types/components/atoms/shape/logo'

const LogoAtom = (props: LogoProps) => {
	// Props
	const { width, height, sx } = props

	return (
		<Grid sx={{ width, height, ...sx }}>
			<Image src="/images/theme/logo.svg" alt="Regiti Logo" width={width} height={height} loading="eager" />
		</Grid>
	)
}

export default LogoAtom
